import AnimatedDialogLayout from "./AnimatedDialogLayout";
import React, { useRef, useState } from "react";
import { useClickAway } from "react-use";
import EmojiPicker from "emoji-picker-react";
import { v4 as uuidv4 } from "uuid";

const colorList = [
  "#000000",
  "#A0ACBD",
  "#875300",
  "#F9F871",
  "#FFBD12",
  "#00B697",
  "#1DA1F2",
  "#945DBE",
  "#945DBE",
  "#FF656D",
];

const CustomListDialog = ({ isOpen, onClose, onAdd }) => {
  const [name, setName] = useState("");
  const [emoji, setEmoji] = useState("");
  const [isEmojiPaletteOpen, setIsEmojiPaletteOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [error, setError] = useState("");
  const emojiRef = useRef(null);

  const handleEmojiClick = (selectedEmoji) => {
    setEmoji(selectedEmoji.emoji);
    setIsEmojiPaletteOpen(false);
  };

  useClickAway(emojiRef, () => {
    if (isEmojiPaletteOpen) {
      setIsEmojiPaletteOpen(false);
    }
  });

  const handleSubmit = () => {
    if (!name) {
      setError("Inserisci il nome della lista");
      setTimeout(() => {
        setError("");
      }, 7000);
      return;
    }
    if (!emoji) {
      setError("Seleziona un’emoji per la lista");
      setTimeout(() => {
        setError("");
      }, 7000);
      return;
    }
    if (!selectedColor) {
      setError("Scegli un colore per la tua nuova lista");
      setTimeout(() => {
        setError("");
      }, 7000);
      return;
    }

    onAdd({ id: uuidv4(), name, emoji, color: selectedColor });
    setIsEmojiPaletteOpen(false);
    setName("");
    setEmoji("");
    setSelectedColor("");
    onClose();
  };

  return (
    <AnimatedDialogLayout
      styleDropdown={{ overflow: "visible" }}
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setIsEmojiPaletteOpen(false);
        setName("");
        setEmoji("");
        setSelectedColor("");
      }}
    >
      <div className="h-[61px] relative border border-[#D1D1D1] space-x-2 rounded-[11px] flex justify-between items-center py-[5px] pr-[6px] pl-[15px]">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="nome della lista"
          className="w-full flex-1 outline-none placeholder:text-[#949494] font-medium text-[16px]"
        />
        <button
          onClick={() => setIsEmojiPaletteOpen((prev) => !prev)}
          className="bg-[#EAEAEA] rounded-[7px] px-[10px] items-center justify-center h-[51px] text-[16px] font-medium"
        >
          {emoji} Scegli Emoji
        </button>
        {isEmojiPaletteOpen && (
          <div
            ref={emojiRef}
            style={{ position: "absolute", top: 63, right: 0 }}
          >
            <EmojiPicker onEmojiClick={handleEmojiClick} emojiSize={16} />
          </div>
        )}
      </div>
      <h2 className="mt-[21px] text-black font-medium text-[18px] leading-21.78px]">
        Scegli il colore
      </h2>
      <div className="mt-[17px] mb-[21px] flex-wrap flex items-center gap-x-[10px] gap-y-[10px]">
        {colorList.map((color) => (
          <div
            key={color}
            onClick={() => setSelectedColor(color)}
            style={{ background: color }}
            className={`${
              selectedColor === color
                ? "border-[3px] border-white shadow-lg"
                : ""
            } w-[36px] flex-shrink-0 h-[36px] rounded-full cursor-pointer`}
          />
        ))}
      </div>

      <button
        onClick={handleSubmit}
        className={`text-white rounded-[11px] h-[51px] w-full mt-4 grid items-center font-semibold text-[18px] ${
          error ? "error-shake bg-red-500" : "bg-primary"
        }`}
      >
        {error ? error : "Salva"}
      </button>
    </AnimatedDialogLayout>
  );
};

export default CustomListDialog;
